import React, { useState } from "react";
import {
  FiLogOut,
  FiChevronDown,
  FiHome,
  FiPlus,
  FiList,
  FiUsers,
  FiBook,
} from "react-icons/fi";
import { GrUserWorker } from "react-icons/gr";
export default function Sidebar() {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

  // Example logout function inside component

  return (
    <div className="h-screen w-72 bg-gradient-to-b from-slate-800 to-slate-900 text-white flex flex-col justify-between shadow-2xl">
      {/* Top - Logo */}
      <div className="p-6">
        <div className="flex items-center space-x-3">
          <img
            src="/logo192.png"
            alt="Logo"
            className="w-14 h-14 rounded-full"
          />
          <span className="text-2xl font-bold text-orange-400">
            Room Booking
          </span>
        </div>

        {/* Dashboard */}
        <div className="mt-8 space-y-2">
          <div className="w-full flex items-center justify-between py-2 px-4 rounded-lg hover:bg-slate-700 transition">
            <a
              href="/babafakruddin/admin/dashboard"
              className="flex items-center gap-2"
            >
              <FiHome /> Dashboard
            </a>
          </div>

          {/* Rooms */}
          <button
            onClick={() => toggleMenu("rooms")}
            className="w-full flex items-center justify-between py-2 px-4 rounded-lg hover:bg-slate-700 transition"
          >
            <span className="flex items-center gap-2">
              <FiList /> Rooms
            </span>
            <FiChevronDown />
          </button>
          {openMenu === "rooms" && (
            <div className="ml-6 space-y-2 text-md text-slate-300">
              <a
                href="/babafakruddin/admin/view-rooms"
                className="block pb-2 hover:text-white"
              >
                View Rooms
              </a>

              <a
                href="/babafakruddin/admin/addRooms"
                className="block  pb-2 hover:text-white"
              >
                Add Room
              </a>
            </div>
          )}
          {/* Staffs */}
          <button
            onClick={() => toggleMenu("staffs")}
            className="w-full flex items-center justify-between py-2 px-4 rounded-lg hover:bg-slate-700 transition"
          >
            <span className="flex items-center gap-2">
              <GrUserWorker /> Staff
            </span>
            <FiChevronDown />
          </button>
          {openMenu === "staffs" && (
            <div className="ml-6 space-y-2 text-md text-slate-300">
              <a
                href="/babafakruddin/admin/view-rooms"
                className="block pb-2 hover:text-white"
              >
                View staff
              </a>

              <a
                href="/babafakruddin/admin/createUser"
                className="block  pb-2 hover:text-white"
              >
                Add Staff
              </a>
            </div>
          )}
          {/* Customers */}
          <div
            onClick={() => toggleMenu("customers")}
            className="w-full flex items-center justify-between py-2 px-4 rounded-lg hover:bg-slate-700 transition"
          >
            <a href="/customer" className="flex items-center gap-2">
              <FiUsers /> Customers
            </a>
          </div>

          {/* Bookings */}

          <button
            onClick={() => toggleMenu("bookings")}
            className="w-full flex items-center justify-between py-2 px-4 rounded-lg hover:bg-slate-700 transition"
          >
            <span className="flex items-center gap-2">
              <FiBook /> Bookings
            </span>
            <FiChevronDown />
          </button>

          {openMenu === "bookings" && (
            <div className="ml-6 space-y-2 text-md text-slate-300">
              <a
                href="/babafakruddin/admin/view-transaction-details"
                className="block pb-2 hover:text-white"
              >
                Transaction Details
              </a>

              <a
                href="/babafakruddin/admin/book_for_customer"
                className="block  pb-2 hover:text-white"
              >
                Book for user
              </a>
            </div>
          )}
        </div>
      </div>

      {/* Bottom - Logout */}
      <div className="p-6 border-t border-slate-700">
        <button
          onClick={async () => {
            try {
              const res = await fetch(`${BASE_URL}/users/logout.php`, {
                method: "POST",
                credentials: "include",
              });
              const data = await res.json();
              if (data.success) {
                window.location.href = "/babafakruddin-admin-login";
              }
            } catch (err) {
              console.error("Logout failed:", err);
            }
          }}
          className="flex items-center gap-3 text-red-400 hover:text-red-300 transition"
        >
          <FiLogOut />
          Logout
        </button>
      </div>
    </div>
  );
}
